module.exports = __webpack_public_path__ + "media/icons/nav-marketplace@3x-blue-26cb7262.png";